import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flow-totals-charts" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-one-third-widescreen" }
const _hoisted_4 = { class: "island" }
const _hoisted_5 = { class: "column is-one-third-widescreen" }
const _hoisted_6 = { class: "island" }
const _hoisted_7 = { class: "column is-one-third-widescreen" }
const _hoisted_8 = { class: "island" }

import TotalsDoughnutChart from './TotalsDoughnutChart.vue';
import { useFlowReport } from '@/features/reports/components/flows/useFlowReport';
import { ReportType } from '@/features/reports/models/reportType';
import { watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FlowTotalsCharts',
  emits: ["loaded"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { isDataLoaded, loadingError, data } = useFlowReport(ReportType.FLOW_TOTALS);
watch([isDataLoaded, loadingError], () => {
  if (isDataLoaded.value) emit('loaded');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TotalsDoughnutChart, {
            class: "totals-doughnut-chart",
            title: "Most Completed",
            "sub-title": "Total Completed",
            "max-items": 10,
            "loaded-data": _unref(isDataLoaded),
            "loading-error": _unref(loadingError),
            data: _unref(data),
            series: "Completed"
          }, null, 8, ["loaded-data", "loading-error", "data"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TotalsDoughnutChart, {
            class: "totals-doughnut-chart",
            title: "Most Escalated",
            "sub-title": "Total Escalated",
            "max-items": 10,
            "loaded-data": _unref(isDataLoaded),
            "loading-error": _unref(loadingError),
            data: _unref(data),
            series: "HandedOver"
          }, null, 8, ["loaded-data", "loading-error", "data"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(TotalsDoughnutChart, {
            class: "totals-doughnut-chart",
            title: "Most Abandoned",
            "sub-title": "Total Abandoned",
            "max-items": 10,
            "loaded-data": _unref(isDataLoaded),
            "loading-error": _unref(loadingError),
            data: _unref(data),
            series: "Abandoned"
          }, null, 8, ["loaded-data", "loading-error", "data"])
        ])
      ])
    ])
  ]))
}
}

})